import sanitizeHtml from 'sanitize-html';

import i18n from '../../../app/i18n';
import {
  actionTexts,
  quizTexts,
  surveyTexts,
} from '../components/Interaction/tileAndButtonTexts';
import {
  ACTION,
  QUIZ,
  SURVEY,
  QA,
  TRUE_FALSE,
  MULTIPLE_CHOICE,
  FEEDBACK,
  FREE_RESPONSE,
  RSVP,
  CHANGE_EMAIL,
  INVITE_SPOUSE,
} from './constants';
import { tileText } from '../components/Interaction/interactionTypeOptions';

const buildQuizAnswers = option => {
  switch (option) {
    case TRUE_FALSE:
      return [
        quizTexts[option].buttonTextTrue,
        quizTexts[option].buttonTextFalse,
      ];
    case MULTIPLE_CHOICE:
      return [quizTexts[option].buttonText, quizTexts[option].buttonText];
    default:
      return [];
  }
};

const buildSurveyAnswers = option => {
  switch (option) {
    case MULTIPLE_CHOICE:
      return [
        surveyTexts[option].buttonText,
        surveyTexts[option].buttonText,
        surveyTexts[option].buttonText,
      ];
    case FEEDBACK:
      return [
        surveyTexts[option].buttonText.stronglyAgree,
        surveyTexts[option].buttonText.agree,
        surveyTexts[option].buttonText.neutral,
        surveyTexts[option].buttonText.disagree,
        surveyTexts[option].buttonText.stronglyDisagree,
      ];
    case FREE_RESPONSE:
      return [
        i18n.t('tileForm:interaction.types.survey.free_response.answerValue'),
      ];
    case RSVP:
      return [
        surveyTexts[option].buttonText.yes,
        surveyTexts[option].buttonText.no,
        surveyTexts[option].buttonText.maybe,
      ];
    case CHANGE_EMAIL:
      return [
        surveyTexts[option].buttonText.changeMyEmail,
        surveyTexts[option].buttonText.keepCurrentEmail,
      ];
    case INVITE_SPOUSE:
      return [
        surveyTexts[option].buttonText.haveDependentAndWantToInvite,
        surveyTexts[option].buttonText.haveDependentAndDontWantToInvite,
        surveyTexts[option].buttonText.dontHaveDependent,
      ];
    default:
      return [];
  }
};

export const defaultAnswers = (type, option) => {
  switch (type) {
    case ACTION:
      return [actionTexts[option].buttonText];
    case QUIZ:
      return buildQuizAnswers(option);
    case SURVEY:
      return buildSurveyAnswers(option);
    case QA:
      return [
        i18n.t('tileForm:interaction.types.questionAnswer.buttonText.yes'),
        i18n.t('tileForm:interaction.types.questionAnswer.buttonText.no'),
      ];
    default:
      return [];
  }
};

export const questionDefaultValue = (selectedType, selectedOption) => {
  switch (selectedType) {
    case ACTION:
    case QUIZ:
    case SURVEY:
      return tileText[selectedOption];
    case QA:
      return tileText[selectedType];
    default:
      return null;
  }
};

export const sanitizedDescription = description =>
  sanitizeHtml(description, { allowedTags: [] }).replace(/\n/g, '');
